import { lazy, Suspense } from "react";

import { useT } from "../i18n";

// xterm.js stays out of the shell's chunk, as for the workspace terminal.
const EnvironmentTerminalPage = lazy(() => import("./EnvironmentTerminal"));

export default function EnvironmentTerminalLazy() {
  const t = useT().workloads.environment.shell;
  return (
    <Suspense fallback={<div className="page note">{t.loading}</div>}>
      <EnvironmentTerminalPage />
    </Suspense>
  );
}
